import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { enqueueRequestErrorSnackbar, enqueueSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import i18next from 'i18next';

const name = 'regenerateCertificate';

export const regenerateCertificate = createAsyncThunk(`${name}/post`, async (accreditationId: string, { dispatch }) => {
  try {
    await axios.post(`/api/v1/accreditations/${accreditationId}/regenerate-certificate`);

    dispatch(
      enqueueSnackbar({
        message:
          i18next.t('newDashboard.certifications.certificateRefreshRequestSent', 'Certificate refresh request sent') ||
          'Certificate refresh request sent',
        options: {
          variant: 'success'
        }
      })
    );
  } catch (error) {
    dispatch(enqueueRequestErrorSnackbar());
    throw error;
  }
});
